
import { Action, createReducer, on } from '@ngrx/store';
import { IClient } from '@interfaces/client.interface';
import { ClientActions } from './actions';
import { IMessageApi } from '@interfaces/rmessage-api.interface';

interface ClientState {
  client: IClient;
  clientList: IClient[];
  driver: IClient;
  error: any;
  loading: boolean;
  message: any;
}

const initialState: ClientState = {
  client: <IClient>{},
  clientList: [],
  driver: <IClient>{},
  error: null,
  loading: false,
  message: null,
};

const featureReducer = createReducer(
  initialState,
  on(ClientActions.createClient, (state) => ({
    ...resetFlags(state),
    loading: true,
  })),
  on(ClientActions.createClientSuccess, (state, { client }) => ({
    ...resetFlags(state),
    client,
    message:"Cliente Creado satisfactoriamente."
  })),
  on(ClientActions.updateClient, (state) => ({
    ...resetFlags(state),
    loading: true,
  })),
  on(ClientActions.updateClientSuccess, (state, { client }) => ({
    ...resetFlags(state),
    client,
  })),
  on(ClientActions.searchClients, (state) => ({
    ...resetFlags(state),
    loading: true,
  })),
  on(ClientActions.searchClientsSuccess, (state, { clientList }) => ({
    ...resetFlags(state),
    clientList,
  })),
  on(ClientActions.setClient, (state, { client }) => ({
    ...resetFlags(state),
    client,
  })),
  on(ClientActions.setDriver, (state, { client }) => ({
    ...resetFlags(state),
    driver: client,
  })),
  on(ClientActions.getErrors, (state, { error }) => {
    return {
      ...resetFlags(state),
      error:error.error,
    }
  }
  ),
  on(ClientActions.setMessage, (state, { message }) => ({
    ...resetFlags(state),
    message,
  })),
  on(ClientActions.reset, (state) => ({
    ...resetFlags(state),
  })),
);
const resetFlags = (state: ClientState): ClientState => {
  return {
    ...state,
    error: null,
    loading: false,
    message: null,
  };
};
function reducer(state: ClientState | undefined, action: Action) {
  return featureReducer(state, action);
}
const getError = (state: ClientState) => state.error;
const getLoading = (state: ClientState) => state.loading;
const getMessage = (state: ClientState) => state.message;

const getClient = (state: ClientState) => state.client;
const getClientList = (state: ClientState) => state.clientList;
const getDriver = (state: ClientState) => state.driver;

export const ClientReducer = {
  reducer,
  getError,
  getLoading,
  getMessage,

  getClient,
  getClientList,
  getDriver

}
export {
  ClientState
}
